import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { EmailConfig, SaveEmailConfigInput } from '@bom/shared';
import { api } from '../lib/apiClient';

/** 读取（不含授权码；has_password 表示是否已设过密码） */
export type EmailConfigView = (EmailConfig & { has_password?: boolean }) | null;

export function useEmailConfig(tid: string | undefined) {
  return useQuery({
    queryKey: ['email-config', tid],
    queryFn: () =>
      api.get<{ config: EmailConfigView }>(`/tenants/${tid}/email-config`).then((r) => r.config),
    enabled: !!tid,
  });
}

export function useSaveEmailConfig(tid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SaveEmailConfigInput) =>
      api.put<void>(`/tenants/${tid}/email-config`, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['email-config', tid] });
      qc.invalidateQueries({ queryKey: ['smtp-accounts'] }); // 保存同时收录到个人邮箱簿
    },
  });
}

export function useDeleteEmailConfig(tid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.del<void>(`/tenants/${tid}/email-config`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['email-config', tid] }),
  });
}

export function useTestEmail(tid: string) {
  return useMutation({
    mutationFn: (to: string) =>
      api.post<{ ok: boolean }>(`/tenants/${tid}/email-config/test`, { to }),
  });
}
